(function () {
  'use strict';

  function initFormRecesso(container) {
    if (!container || container.dataset.frInitialized === 'true') return;
    container.dataset.frInitialized = 'true';

    var form = container.querySelector('[data-fr-form]');
    var modal = container.querySelector('[data-fr-modal]');
    var formHeader = container.querySelector('[data-fr-form-header]');
    var successHeader = container.querySelector('[data-fr-success-header]');
    var mockOutput = container.querySelector('[data-fr-mock-output]');
    var mockBanner = container.querySelector('.fr-form-recesso__mock-banner');
    var submitBtn = container.querySelector('[data-fr-submit]');
    var confirmBtn = container.querySelector('[data-fr-confirm]');
    var editBtn = container.querySelector('[data-fr-edit]');
    var overlay = container.querySelector('[data-fr-overlay]');

    if (!form || !modal) return;

    var submissionMethod = container.dataset.submissionMethod || 'mock';
    var customEndpoint = container.dataset.customEndpoint || '';
    var shopName = container.dataset.shopName || '';
    var shopDomain = container.dataset.shopDomain || '';
    var shopLanguage = container.dataset.shopLanguage || '';
    var shopCountry = container.dataset.shopCountry || '';

    var fields = {
      firstName: form.querySelector('[name="fr_first_name"]'),
      lastName: form.querySelector('[name="fr_last_name"]'),
      email: form.querySelector('[name="fr_email"]'),
      returnReason: form.querySelector('[name="fr_return_reason"]'),
      product: form.querySelector('[name="fr_product"]'),
      orderId: form.querySelector('[name="fr_order_id"]')
    };

    var privacyField = form.querySelector('[name="fr_privacy"]');

    var summaryEls = {
      firstName: modal.querySelector('[data-fr-summary="first_name"]'),
      lastName: modal.querySelector('[data-fr-summary="last_name"]'),
      email: modal.querySelector('[data-fr-summary="email"]'),
      orderId: modal.querySelector('[data-fr-summary="order_id"]'),
      product: modal.querySelector('[data-fr-summary="product"]'),
      returnReason: modal.querySelector('[data-fr-summary="return_reason"]')
    };

    function getFieldErrorEl(field) {
      return field && field.closest('.fr-form-recesso__field')
        ? field.closest('.fr-form-recesso__field').querySelector('[data-fr-error]')
        : null;
    }

    function clearErrors() {
      Object.keys(fields).forEach(function (key) {
        var field = fields[key];
        if (!field) return;
        field.classList.remove('fr-form-recesso__input--error', 'fr-form-recesso__select--error', 'fr-form-recesso__textarea--error');
        var errorEl = getFieldErrorEl(field);
        if (errorEl) errorEl.classList.remove('is-visible');
      });
      if (privacyField) clearFieldError(privacyField);
    }

    function clearFieldError(field) {
      if (!field) return;
      field.classList.remove('fr-form-recesso__input--error', 'fr-form-recesso__select--error', 'fr-form-recesso__textarea--error');
      var errorEl = getFieldErrorEl(field);
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('is-visible');
      }
    }

    function isFieldValid(field) {
      if (!field) return true;
      var value = field.value.trim();
      if (!value) return false;
      if (field === fields.email) return isValidEmail(value);
      return true;
    }

    function handleFieldInput(event) {
      if (isFieldValid(event.target)) clearFieldError(event.target);
    }

    function showFieldError(field, message) {
      if (!field) return false;
      field.classList.add(
        field.tagName === 'SELECT' ? 'fr-form-recesso__select--error' :
        field.tagName === 'TEXTAREA' ? 'fr-form-recesso__textarea--error' :
        'fr-form-recesso__input--error'
      );
      var errorEl = getFieldErrorEl(field);
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.classList.add('is-visible');
      }
      return false;
    }

    function isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function validateForm() {
      clearErrors();
      var valid = true;
      var requiredMsg = container.dataset.errorRequired || 'Campo obbligatorio';
      var emailMsg = container.dataset.errorEmail || 'Inserisci un indirizzo email valido';

      if (!fields.firstName || !fields.firstName.value.trim()) {
        showFieldError(fields.firstName, requiredMsg);
        valid = false;
      }
      if (!fields.lastName || !fields.lastName.value.trim()) {
        showFieldError(fields.lastName, requiredMsg);
        valid = false;
      }
      if (!fields.email || !fields.email.value.trim()) {
        showFieldError(fields.email, requiredMsg);
        valid = false;
      } else if (!isValidEmail(fields.email.value.trim())) {
        showFieldError(fields.email, emailMsg);
        valid = false;
      }
      if (!fields.returnReason || !fields.returnReason.value.trim()) {
        showFieldError(fields.returnReason, requiredMsg);
        valid = false;
      }
      if (!fields.product || !fields.product.value.trim()) {
        showFieldError(fields.product, requiredMsg);
        valid = false;
      }
      if (!fields.orderId || !fields.orderId.value.trim()) {
        showFieldError(fields.orderId, requiredMsg);
        valid = false;
      }
      if (!privacyField || !privacyField.checked) {
        showFieldError(privacyField, container.dataset.errorPrivacy || 'Devi accettare l\'informativa sulla privacy.');
        valid = false;
      }

      return valid;
    }

    function openModal() {
      if (summaryEls.firstName) summaryEls.firstName.textContent = fields.firstName.value.trim();
      if (summaryEls.lastName) summaryEls.lastName.textContent = fields.lastName.value.trim();
      if (summaryEls.email) summaryEls.email.textContent = fields.email.value.trim();
      if (summaryEls.orderId) summaryEls.orderId.textContent = fields.orderId.value.trim();
      if (summaryEls.product) summaryEls.product.textContent = fields.product.value.trim();
      if (summaryEls.returnReason) summaryEls.returnReason.textContent = fields.returnReason.value.trim();

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fr-modal-open');
      if (confirmBtn) confirmBtn.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fr-modal-open');
    }

    function padTime(value, length) {
      var str = String(value);
      while (str.length < length) str = '0' + str;
      return str;
    }

    function toLocalISOString(date) {
      var tzOffset = -date.getTimezoneOffset();
      var sign = tzOffset >= 0 ? '+' : '-';
      var absOffset = Math.abs(tzOffset);
      var offsetHours = padTime(Math.floor(absOffset / 60), 2);
      var offsetMinutes = padTime(absOffset % 60, 2);

      return (
        date.getFullYear() + '-' +
        padTime(date.getMonth() + 1, 2) + '-' +
        padTime(date.getDate(), 2) + 'T' +
        padTime(date.getHours(), 2) + ':' +
        padTime(date.getMinutes(), 2) + ':' +
        padTime(date.getSeconds(), 2) + '.' +
        padTime(date.getMilliseconds(), 3) +
        sign + offsetHours + ':' + offsetMinutes
      );
    }

    function captureConfirmationTimestamp() {
      var now = new Date();
      return {
        iso: toLocalISOString(now),
        local: now.toLocaleString('it-IT', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
      };
    }

    function buildApiPayload(confirmedAt, recaptchaToken) {
      var payload = {
        first_name: fields.firstName.value.trim(),
        last_name: fields.lastName.value.trim(),
        email: fields.email.value.trim(),
        order_id: fields.orderId.value.trim(),
        product_name: fields.product.value.trim(),
        return_reason: fields.returnReason.value.trim(),
        privacy_consent: !!(privacyField && privacyField.checked),
        confirmed_at: confirmedAt ? confirmedAt.iso : null,
        store_name: shopName,
        shop_domain: shopDomain,
        language: shopLanguage,
        country: shopCountry
      };

      if (recaptchaToken) {
        payload.recaptcha_token = recaptchaToken;
      }

      return payload;
    }

    function getRecaptchaToken() {
      var siteKey = container.dataset.recaptchaSiteKey;
      var action = container.dataset.recaptchaAction || 'recesso';

      return new Promise(function (resolve, reject) {
        if (!siteKey) {
          reject(new Error('reCAPTCHA site key missing'));
          return;
        }
        if (typeof grecaptcha === 'undefined') {
          reject(new Error('reCAPTCHA not loaded'));
          return;
        }

        grecaptcha.ready(function () {
          grecaptcha.execute(siteKey, { action: action })
            .then(resolve)
            .catch(reject);
        });
      });
    }

    function submitViaCustomEndpoint(confirmedAt, recaptchaToken) {
      var payload = buildApiPayload(confirmedAt, recaptchaToken);

      return fetch(customEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
    }

    function submitViaMock(confirmedAt) {
      var payload = buildApiPayload(confirmedAt);
      var delay = parseInt(container.dataset.mockDelay, 10) || 800;

      return new Promise(function (resolve) {
        setTimeout(function () {
          console.log('[Form Recesso] Mock API — payload inviato:', payload);
          resolve({ ok: true, mockPayload: payload });
        }, delay);
      });
    }

    function showSuccess(mockPayload) {
      form.classList.add('is-hidden');
      closeModal();

      if (formHeader) formHeader.hidden = true;
      if (mockBanner) mockBanner.hidden = true;
      if (successHeader) successHeader.hidden = false;

      if (mockPayload && mockOutput) {
        mockOutput.hidden = false;
        mockOutput.innerHTML = '';

        var payloadEl = document.createElement('pre');
        payloadEl.className = 'fr-form-recesso__mock-payload';
        payloadEl.textContent = JSON.stringify(mockPayload, null, 2);
        mockOutput.appendChild(payloadEl);
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function setConfirmLoading(loading) {
      if (!confirmBtn) return;
      confirmBtn.disabled = loading;
      if (loading) {
        confirmBtn.dataset.originalText = confirmBtn.textContent;
        confirmBtn.innerHTML = '<span class="fr-form-recesso__spinner"></span>' + (container.dataset.submittingLabel || 'Invio in corso...');
      } else if (confirmBtn.dataset.originalText) {
        confirmBtn.textContent = confirmBtn.dataset.originalText;
      }
    }

    function handleConfirm() {
      var confirmedAt = captureConfirmationTimestamp();
      setConfirmLoading(true);

      var submitPromise;

      if (submissionMethod === 'mock') {
        submitPromise = submitViaMock(confirmedAt);
      } else if (customEndpoint) {
        submitPromise = getRecaptchaToken()
          .then(function (recaptchaToken) {
            return submitViaCustomEndpoint(confirmedAt, recaptchaToken);
          });
      } else {
        setConfirmLoading(false);
        alert(container.dataset.errorSubmit || 'Si è verificato un errore. Riprova più tardi.');
        return;
      }

      submitPromise
        .then(function (response) {
          if (submissionMethod === 'custom_endpoint' && !response.ok) {
            throw new Error('Submission failed');
          }
          showSuccess(response.mockPayload || null);
        })
        .catch(function () {
          alert(container.dataset.errorSubmit || 'Si è verificato un errore. Riprova più tardi.');
        })
        .finally(function () {
          setConfirmLoading(false);
        });
    }

    Object.keys(fields).forEach(function (key) {
      var field = fields[key];
      if (!field) return;
      field.addEventListener('input', handleFieldInput);
      field.addEventListener('change', handleFieldInput);
    });

    if (privacyField) {
      privacyField.addEventListener('change', function () {
        if (privacyField.checked) clearFieldError(privacyField);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (validateForm()) openModal();
    });

    if (confirmBtn) confirmBtn.addEventListener('click', handleConfirm);
    if (editBtn) editBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fr-component]').forEach(initFormRecesso);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target.querySelector('[data-fr-component]');
    if (container) initFormRecesso(container);
  });
})();
